"use client";

import { Accordion } from "@ama-pt/agora-design-system";
import Image from "@/components/atoms/image";
import { motion } from "framer-motion";
import Heading from "@/components/molecules/Heading";
import { InfoAccordionWithImageBlockProps } from "@/page-builder/fragments/InfoAccordionWithImageBlock/types";
import { convertLexicalWithInternalLinks } from "@/lib/lexical";

export default function InfoAccordionWithImageBlockContent(
  data: InfoAccordionWithImageBlockProps
) {
  return (
    <section
      className="container mx-auto flex flex-col-reverse xl:flex-row items-center justify-between gap-32"
      aria-labelledby="faq-title"
    >
      <div className="flex flex-col items-start gap-16 md:gap-[44px] w-full xl:max-w-[696px]">
        <div className="relative">
          <Heading title={data?.title} description={data?.description} />
        </div>
        <div className="flex flex-col w-full">
          {data?.items?.map((faq, index) => (
            <Accordion
              key={index}
              title={faq.title}
              headingTitle={
                <span className="text-neutral-900 text-m-bold">
                  {faq.title}
                </span>
              }
              className=""
            >
              {faq.description && (
                <motion.div
                  layout
                  className="flex gap-4 px-8 pt-2 pb-8"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: convertLexicalWithInternalLinks(
                        faq.description as any
                      ),
                    }}
                    className="text-m-regular text-neutral-900 py-8 prose prose-ul:my-0 marker:text-neutral-900"
                  />
                </motion.div>
              )}
            </Accordion>
          ))}
        </div>
      </div>
      {data?.image && (
        <motion.div
          layout
          className="w-full flex justify-center xl:justify-end xl:items-start xl:w-[488px]"
        >
          <motion.div
            layout
            className="relative aspect-[488/406] w-full max-w-[488px]"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          >
            <Image
              src={data.image?.url}
              alt={data.image?.alt}
              fill
              className="object-contain"
              sizes="(max-width: 768px) 100vw, 488px"
              priority
            />
          </motion.div>
        </motion.div>
      )}
    </section>
  );
}
